module.exports = __webpack_public_path__ + "media/images/save-764e04afa07bdc91788df53927542a1d.svg";